import e from "./SchemaCollapsedPreview.vue.script.js";
//#region src/schema/SchemaCollapsedPreview.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaCollapsedPreview.vue.js.map